<template>
    <div class="site-width uk-animation-fade">

        <Seo :canonical="'/'+$t('association').toLowerCase()" :title="$t('association')"/>

        <div class="menu-headline-distance"/>
        <SiteHeadline is-main
                      :message="$t('association')"/>
        <div class="headline-message-distance"/>

        <HighlightVideoText toggle-sides :service-items="serviceItems"/>

        <div class="section-distance"/>
        <SiteHeadline message="Gründungsmitglieder"/>
        <div class="headline-message-distance"/>
        <SubTeam :team="ambassadors"/>


        <div class="section-distance"/>
        <SiteHeadline message="Das haben wir bisher erreicht"/>
        <div class="headline-message-distance"/>

        <ul v-if="false"
            class="js-filter uk-child-width-1-3@l uk-child-width-1-2@m uk-child-width-1-1 uk-grid-match uk-flex uk-flex-center"
            uk-grid>
            <VideoHeadlineItem v-for="(product, key) in references" :id="product.id+''" :key="key"
                               :data-category="product.category"
                               :headline="$t(product.category)"
                               :isCampaign="product.video_link === ''"
                               :itemKey="key"
                               :logo="product.logo ?getBaseUrl+'/api/storage/app/'+product.logo : ''"
                               :message="product.name"
                               :route="product.video_link === '' ? '/'+$t('references').toLowerCase()+'/'+product.shortname : ''"
                               :shortname="product.shortname"
                               :video="product.video_link"
                               :videoPreview="getBaseUrl+'/api/storage/app/'+product.preview_video"
                               class="item-struct"
                               is-max
            />
        </ul>


        <div class=" uk-child-width-1-3@m uk-child-width-1-1 uk-flex-center" uk-grid>
            <div v-for="index in indexes" :key="index">
                <img :src="require('../../assets/'+getMode+'/references/'+index+'.png')"
                     class="image" uk-img/>
            </div>
        </div>


        <div class="last-button-distance"/>

    </div>
</template>


<script>

import SiteHeadline from "../../components/SiteHeadline.vue";
import Seo from "../../components/Seo.vue";
import HighlightVideoText from "@/components/HighlightVideoText.vue";
import SubTeam from "@/components/SubTeam.vue";
import VideoHeadlineItem from "@/components/VideoHeadlineItem.vue";

export default {
    name: 'Ambassadors',
    components: {
        VideoHeadlineItem,
        SubTeam,
        HighlightVideoText,
        Seo,
        SiteHeadline
    },
    data() {
        return {
            indexes: [1, 2, 3, 4, 5],
            loading: false,

            serviceItems: [
                {
                    headline: "vision",
                    title: "",
                    message: "visionText",
                    image: "Initiatoren.png",
                    text: "<b>Initiatoren:</b> Andreas Olenberg, Daniel Littau, Manuel Mohnke und Timo Wentzel."
                },
            ],


            ambassadors: [
                {
                    name: "Timo Wentzel",
                    titleDE: "Vorstands&shy;vorsitzender",
                    avatar: "twentzel.png",
                },
                {
                    name: "Manuel Mohnke",
                    titleDE: "Stellvertrender Vorstands&shy;vorsitzender",
                    video: "mmohnke.mp4",
                },
                {
                    name: "Daniel Littau",
                    titleDE: "Schatzmeister",
                    video: "dlittau.mp4",
                },
                {
                    name: "Björn Leisten",
                    titleDE: "Schriftführer",
                    video: "bleisten.mp4",
                },
                {
                    name: "Andreas Olenberg",
                    titleDE: "Gründungsmitglied",
                    video: "aolenberg.mp4",
                },
                {
                    name: " Vanessa Mohnke",
                    titleDE: "Gründungsmitglied",
                    avatar: "vmohnke.png",
                },
                {
                    name: "Tanja Kreideweis",
                    titleDE: "Gründungsmitglied",
                    avatar: "tkreideweis.png",
                },
                {
                    name: "Aykut Yalcin",
                    titleDE: "Gründungsmitglied",
                    video: "ayalcin.mp4",
                },

            ]
        };
    },
    created() {
        if (this.getMode !== "cancelcancer") {
            this.routeTo("")
        }
    },
}

</script>


<style lang="scss" scoped>

.image {
    border-radius: $border-radius;
}

</style>
